// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_kOsHX","foot_link":"index_foot_link_cwSK9","list":"index_list_yEEaX","link":"index_link_Kh6X-","copyright":"index_copyright_u87da"};